(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6052],{

/***/ 85925:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/tools/get-keyword-statistics",
      function () {
        return __webpack_require__(74755);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 74755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _src_components_content_ai_tools_GetKeywordStatistics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66928);
/* harmony import */ var _src_components_content_ai_tools_components_ToolsStyleWrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97344);



var PublicDiscoveryKeywordsWrapped = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_content_ai_tools_components_ToolsStyleWrapper__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        component: _src_components_content_ai_tools_GetKeywordStatistics__WEBPACK_IMPORTED_MODULE_1__/* .GetKeywordStatistics */ .c
    });
};
/* harmony default export */ __webpack_exports__["default"] = (PublicDiscoveryKeywordsWrapped);


/***/ }),

/***/ 66928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ GetKeywordStatistics; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(47568);
/* harmony import */ var _home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(282);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(39803);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(30585);
/* harmony import */ var _components_CollapsibleTable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60872);
/* harmony import */ var _utility_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5969);
/* harmony import */ var _public_Spinner_Logo_gif__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55175);
/* harmony import */ var _utility_cr_common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46236);
/* harmony import */ var react_google_recaptcha__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34853);
/* harmony import */ var _components_ToolsStyleWrapper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97344);
/* harmony import */ var _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66306);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(31955);
/* harmony import */ var _components_SkipCaptcha__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(98950);
/* harmony import */ var _utility_services_customHooks__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(89147);
/* harmony import */ var _components_CreditsInfo__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(98910);
















var GetKeywordStatistics = function(param) {
    var classes = param.classes, setShowSignUpPage = param.setShowSignUpPage, user = param.user, handleResetUsage = param.handleResetUsage, _isQwaDashboard = param.isQwaDashboard, isQwaDashboard = _isQwaDashboard === void 0 ? false : _isQwaDashboard, _isCreditsShown = param.isCreditsShown, isCreditsShown = _isCreditsShown === void 0 ? false : _isCreditsShown, _creditsRemaining = param.creditsRemaining, creditsRemaining = _creditsRemaining === void 0 ? 0 : _creditsRemaining, _usagePerDay = param.usagePerDay, usagePerDay = _usagePerDay === void 0 ? 0 : _usagePerDay, hasValidSubscription = param.hasValidSubscription, enableLockedOption = param.enableLockedOption, setShowBuyOnePass = param.setShowBuyOnePass, setIsRedirectToWebflow = param.setIsRedirectToWebflow, _setShowMinimumCreditsNeededMsg = param.setShowMinimumCreditsNeededMsg, setShowMinimumCreditsNeededMsg = _setShowMinimumCreditsNeededMsg === void 0 ? function(a) {} : _setShowMinimumCreditsNeededMsg, setShowVerifyEmailPopup = param.setShowVerifyEmailPopup, _freeToolsUsage = param.freeToolsUsage, freeToolsUsage = _freeToolsUsage === void 0 ? 0 : _freeToolsUsage, _showFreeToolsUsage = param.showFreeToolsUsage, showFreeToolsUsage = _showFreeToolsUsage === void 0 ? false : _showFreeToolsUsage, _isCorpEmail = param.isCorpEmail, isCorpEmail = _isCorpEmail === void 0 ? false : _isCorpEmail;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), input = ref[0], setInput = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), error = ref1[0], setError = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}), data = ref3[0], setData = ref3[1];
    var qttr_tools_auth = js_cookie__WEBPACK_IMPORTED_MODULE_10__/* ["default"].get */ .Z.get("qttr_tools_auth");
    var qttr_tools_daypass_auth = js_cookie__WEBPACK_IMPORTED_MODULE_10__/* ["default"].get */ .Z.get("qttr_tools_daypass_auth");
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), recaptchaValue = ref4[0], setRecaptchaValue = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), captchaError = ref5[0], setCaptchaError = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(1), creditsNeeded = ref6[0], setCreditsNeeded = ref6[1];
    var session = (0,_utility_services_customHooks__WEBPACK_IMPORTED_MODULE_12__/* .useSession */ .kP)();
    var handleRecaptchaChange = function(value) {
        setRecaptchaValue(value);
        setCaptchaError("");
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .trackAnalyticsEvent */ .ec)({
            isAnonymousUser: !user,
            payload: {
                label: "Visited Free Tool",
                component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_NAME.keyword_statistics */ .vG.keyword_statistics,
                tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_CATEGORY.keyword_research */ ._V.keyword_research,
                isQwaDashboard: isQwaDashboard
            }
        });
    }, []);
    var handleClusterKeywords = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var keywords, payload, res, mergedArray, axiosError;
            return _home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.prev = 1;
                        keywords = ((input === null || input === void 0 ? void 0 : input.split(",")) || []).map(function(i) {
                            return i.trim();
                        }).filter(function(i) {
                            return Boolean(i);
                        });
                        if (keywords.length) {
                            _ctx.next = 6;
                            break;
                        }
                        setError("input");
                        return _ctx.abrupt("return");
                    case 6:
                        if (recaptchaValue || qttr_tools_auth || user) {
                            _ctx.next = 9;
                            break;
                        }
                        setCaptchaError("recaptchaValue");
                        return _ctx.abrupt("return");
                    case 9:
                        setCaptchaError("");
                        setError("");
                        payload = {
                            keywords: keywords,
                            include_serp_info: true,
                            language_name: "English",
                            location_code: "2840",
                            language_code: "en",
                            reCAPTCHAToken: recaptchaValue
                        };
                        _ctx.next = 14;
                        return (0,_utility_cr_common__WEBPACK_IMPORTED_MODULE_6__/* .fetchKeywordDfsData */ .jr)(payload, true);
                    case 14:
                        res = _ctx.sent;
                        if (res) {
                            (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .trackAnalyticsEvent */ .ec)({
                                eventFor: "button",
                                buttonText: "",
                                counterName: "".concat(_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_CATEGORY.keyword_research */ ._V.keyword_research, " Outputs"),
                                isAddCount: true,
                                user: user,
                                isAnonymousUser: !user,
                                payload: {
                                    label: "Generate Output",
                                    component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                                    screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                                    tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_NAME.keyword_statistics */ .vG.keyword_statistics,
                                    tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_CATEGORY.keyword_research */ ._V.keyword_research,
                                    special_instructions_yn: input ? "Yes" : "No",
                                    isQwaDashboard: isQwaDashboard,
                                    creditsConsumed: creditsNeeded ? creditsNeeded : 1
                                }
                            });
                            if (handleResetUsage) {
                                handleResetUsage();
                            }
                        }
                        mergedArray = keywords === null || keywords === void 0 ? void 0 : keywords.map(function(obj1) {
                            var obj2 = res === null || res === void 0 ? void 0 : res.data.find(function(obj) {
                                return obj.keyword.toUpperCase() === obj1.toUpperCase();
                            });
                            return {
                                keyword: obj1,
                                "search volume": obj2 ? obj2.search_volume : null,
                                "average CPC": obj2 ? obj2.averageCPC : null,
                                "keyword difficulty": obj2 ? obj2.keyword_difficulty : null
                            };
                        });
                        mergedArray.sort(function(a, b) {
                            return b["search volume"] - a["search volume"];
                        });
                        setData(mergedArray);
                        _ctx.next = 26;
                        break;
                    case 21:
                        _ctx.prev = 21;
                        _ctx.t0 = _ctx["catch"](1);
                        axiosError = _ctx.t0;
                        if (axiosError === null || axiosError === void 0 ? void 0 : axiosError.response) {
                            if (axiosError.response.status === 403) {
                                setShowSignUpPage(_components_ToolsStyleWrapper__WEBPACK_IMPORTED_MODULE_8__/* .CONTINUE_USING_TEXT */ .gt, {
                                    tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_NAME.keyword_statistics */ .vG.keyword_statistics,
                                    tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_CATEGORY.keyword_research */ ._V.keyword_research
                                });
                                (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .trackAnalyticsEvent */ .ec)({
                                    eventFor: "button",
                                    isAnonymousUser: !user,
                                    payload: {
                                        label: "Reached your maximum usage limit",
                                        component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                                        screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                                        tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_NAME.keyword_statistics */ .vG.keyword_statistics,
                                        tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_CATEGORY.keyword_research */ ._V.keyword_research,
                                        isQwaDashboard: isQwaDashboard
                                    }
                                });
                            }
                        }
                        console.error("handleClusterKeywords:: ", _ctx.t0);
                    case 26:
                        _ctx.prev = 26;
                        setRecaptchaValue(null);
                        (0,_utility_common__WEBPACK_IMPORTED_MODULE_4__/* .resetCaptcha */ .Ler)();
                        setLoading(false);
                        return _ctx.finish(26);
                    case 31:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    21,
                    26,
                    31
                ]
            ]);
        }));
        return function handleClusterKeywords() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleInputChange = function(event) {
        var value = event.target.value;
        var keywords = value.split(",");
        setError("");
        if (keywords.length > 50 && !hasValidSubscription && !enableLockedOption) {
            keywords = keywords.slice(0, 50); // Keep only the first 50 keywords
            setError("Please sign up to process more than 50 keywords.");
            setInput(keywords.join(","));
        } else {
            setInput(value);
        }
    };
    var handleDownload = function() {
        var ref = (0,_utility_common__WEBPACK_IMPORTED_MODULE_4__/* .createAnExcelSheet */ .mDv)("Discover Keywords"), ExcelJSWorkbook = ref.ExcelJSWorkbook, worksheet = ref.worksheet;
        // define columns for the worksheet
        worksheet.columns = [
            {
                header: "Keyword",
                key: "keyword",
                width: 20
            },
            {
                header: "Search Volume",
                key: "search_volume",
                width: 15
            },
            {
                header: "Average CPC",
                key: "avg_cpc",
                width: 15
            },
            {
                header: "Keyword Difficulty",
                key: "keyword_difficulty",
                width: 15
            }, 
        ];
        if (Array.isArray(data)) {
            data.forEach(function(keywordObj) {
                worksheet.addRow({
                    keyword: keywordObj["keyword"],
                    search_volume: keywordObj["search volume"],
                    avg_cpc: keywordObj["average CPC"],
                    keyword_difficulty: keywordObj["keyword difficulty"]
                });
            });
        }
        (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .trackAnalyticsEvent */ .ec)({
            eventFor: "button",
            buttonText: "",
            counterName: "Outputs Accepted",
            isAddCount: true,
            user: user,
            isAnonymousUser: !user,
            payload: {
                label: "Download Generated Output",
                component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_NAME.keyword_statistics */ .vG.keyword_statistics,
                tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_CATEGORY.keyword_research */ ._V.keyword_research,
                special_instructions_yn: input ? "Yes" : "No",
                isQwaDashboard: isQwaDashboard
            }
        });
        (0,_utility_common__WEBPACK_IMPORTED_MODULE_4__/* .downloadAnCsv */ .Ntz)(ExcelJSWorkbook, "quattr_generated_keyword_clusters");
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var promptFor = _utility_common__WEBPACK_IMPORTED_MODULE_4__/* .PAID_TOOLS_PROMPT_FOR.KEYWORD_STATISTICS */ .rMq.KEYWORD_STATISTICS;
        setCreditsNeeded((0,_utility_common__WEBPACK_IMPORTED_MODULE_4__/* .getToolsUsageCreditsNeeded */ .Nmb)(promptFor, {}));
    }, [
        user
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: classes.container,
        children: [
            loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: classes.overlay
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: classes.loader,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                            src: _public_Spinner_Logo_gif__WEBPACK_IMPORTED_MODULE_5__/* ["default"].src */ .Z.src,
                            alt: "Loading..."
                        })
                    })
                ]
            }),
            data && Object.keys(data).length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_CollapsibleTable__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        isSingleLevel: true,
                        classes: classes,
                        data: {
                            clusters: data
                        },
                        keyName: "keyword",
                        columns: [
                            {
                                name: "Keyword"
                            },
                            {
                                name: "Avg. Search Volume",
                                width: "95px"
                            },
                            {
                                name: "Avg. CPC",
                                width: "95px"
                            },
                            {
                                name: "Keyword Difficulty",
                                width: "81px"
                            }, 
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: classes.buttonGroup,
                        style: {
                            marginTop: "16px"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                className: "".concat(classes.toolsYellowCTA, " ").concat(classes.toolsOutlinedCTA, " ").concat(classes.button),
                                disabled: loading,
                                style: {
                                    float: "right"
                                },
                                onClick: function() {
                                    setData({});
                                    (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .trackAnalyticsEvent */ .ec)({
                                        eventName: "Clicked on Go back",
                                        payload: {
                                            label: "Clicked on Go back"
                                        }
                                    });
                                },
                                children: "Go back"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                className: "".concat(classes.toolsYellowCTA, " ").concat(classes.button),
                                disabled: loading,
                                style: {
                                    float: "right"
                                },
                                onClick: handleDownload,
                                children: "Download"
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                        multiline: true,
                        // fullWidth
                        value: input,
                        className: classes.textAreaInput,
                        onChange: handleInputChange,
                        maxRows: 5,
                        InputProps: {
                            style: {
                                backgroundColor: "#fff",
                                borderRadius: "4px !important",
                                padding: "16px"
                            },
                            disableUnderline: true
                        },
                        error: !!error,
                        minRows: 5,
                        helperText: error.includes("input") ? "* Required" : error.includes("Please sign up") ? error : "",
                        rows: 5,
                        variant: "filled",
                        placeholder: "Enter list of keywords separated by ,"
                    }),
                    !qttr_tools_auth && !user && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_google_recaptcha__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                className: classes.recaptcha,
                                sitekey: "6LfNnmAqAAAAAFm-6SDC8c9lFenCJX2_QkckWpsd",
                                onChange: handleRecaptchaChange
                            }),
                            (captchaError === null || captchaError === void 0 ? void 0 : captchaError.includes("recaptchaValue")) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                className: "red",
                                children: "Please complete the reCAPTCHA to verify you're human."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_SkipCaptcha__WEBPACK_IMPORTED_MODULE_11__/* .SkipCaptcha */ .h, {
                                classes: classes,
                                meta: {
                                    component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                                    screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                                    tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_NAME.keyword_statistics */ .vG.keyword_statistics,
                                    tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_CATEGORY.keyword_research */ ._V.keyword_research
                                },
                                setShowVerifyEmailPopup: setShowVerifyEmailPopup
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "".concat(isCreditsShown ? classes.creditsShown : classes.freeCreditsShown),
                        children: [
                            isCreditsShown ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_CreditsInfo__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                classes: classes,
                                creditsRemaining: creditsRemaining,
                                creditsNeeded: creditsNeeded,
                                usagePerDay: usagePerDay
                            }) : !isQwaDashboard || showFreeToolsUsage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_CreditsInfo__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                classes: classes,
                                creditsRemaining: freeToolsUsage,
                                creditsNeeded: creditsNeeded,
                                usagePerDay: isCorpEmail ? 10 : 7,
                                showFreeToolsUsage: showFreeToolsUsage
                            }) : null,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "d-flex ".concat(classes.buttonGroup),
                                style: {
                                    marginTop: "16px"
                                },
                                children: [
                                    !hasValidSubscription && !enableLockedOption ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                        style: {
                                            marginRight: "16px"
                                        },
                                        children: [
                                            input.split(",").filter(function(i) {
                                                return Boolean(i);
                                            }).length,
                                            "/50"
                                        ]
                                    }) : null,
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                        className: classes.toolsYellowCTA,
                                        disabled: loading,
                                        style: {
                                            float: "right"
                                        },
                                        onClick: function() {
                                            return (0,_utility_common__WEBPACK_IMPORTED_MODULE_4__/* .handleGenerateOutput */ .jx$)(creditsRemaining, creditsNeeded, isQwaDashboard, session, qttr_tools_daypass_auth, setShowMinimumCreditsNeededMsg, setShowBuyOnePass, handleClusterKeywords, _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .trackAnalyticsEvent */ .ec, freeToolsUsage, showFreeToolsUsage);
                                        },
                                        children: "Get Keyword Statistics"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 60872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57394);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88222);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(56847);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(79895);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(7206);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(83750);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(99613);
/* harmony import */ var _material_ui_icons_KeyboardArrowDown__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51115);
/* harmony import */ var _material_ui_icons_NavigateNext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98121);
/* harmony import */ var _utility_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5969);
/* harmony import */ var _utility_services_keywordHelper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53041);








var useRowStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    root: {
        "& > *": {
            borderBottom: "unset"
        }
    }
});
function Row(props) {
    var cluster = props.cluster, name = props.name, parent_classes = props.parent_classes, isSingleLevel = props.isSingleLevel, keyName = props.keyName;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), open = ref[0], setOpen = ref[1];
    var classes = useRowStyles();
    //   Object.keys(cluster).filter(key => typeof cluster[key] !== "object")
    var keys = isSingleLevel ? Object.keys(cluster).filter(function(i) {
        return i !== keyName;
    }) : [
        "search volume",
        "keyword difficulty"
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                className: "".concat(parent_classes.tableRow, " ").concat(classes.root),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        className: parent_classes.tableCell,
                        children: !isSingleLevel ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            "aria-label": "expand row",
                            size: "small",
                            onClick: function() {
                                return setOpen(!open);
                            },
                            children: open ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_KeyboardArrowDown__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_NavigateNext__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
                        }) : null
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        className: parent_classes.tableCell,
                        scope: "row",
                        children: name
                    }),
                    keys.map(function(key, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            className: parent_classes.tableCell,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: "keyword-difficulty-score-circle",
                                children: [
                                    typeof cluster[key] == "number" ? (0,_utility_common__WEBPACK_IMPORTED_MODULE_2__/* .numberFormatter */ .V2q)(cluster[key]) : cluster[key] || "--",
                                    key === "keyword difficulty" && (cluster[key] ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "m-0",
                                        style: {
                                            width: "15px",
                                            height: "15px",
                                            borderRadius: "15px",
                                            background: (0,_utility_services_keywordHelper__WEBPACK_IMPORTED_MODULE_9__/* .getKeywordDificultyColorRange */ .XP)(cluster[key] || 0)
                                        }
                                    }) : null)
                                ]
                            })
                        }, index);
                    })
                ]
            }),
            name && Object.keys(cluster).filter(function(key) {
                return typeof cluster[key] === "object";
            }).map(function(subName, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: "".concat(parent_classes.tableRow, " ").concat(classes.root),
                    children: open && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                className: parent_classes.tableCell
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                className: parent_classes.tableCell,
                                scope: "row",
                                children: subName
                            }),
                            keys.map(function(key, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    className: parent_classes.tableCell,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "keyword-difficulty-score-circle",
                                        children: [
                                            typeof cluster[subName][key] == "number" ? (0,_utility_common__WEBPACK_IMPORTED_MODULE_2__/* .numberFormatter */ .V2q)(cluster[subName][key]) : cluster[subName][key] || "--",
                                            key === "keyword difficulty" && (cluster[subName][key] ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "m-0",
                                                style: {
                                                    width: "15px",
                                                    height: "15px",
                                                    borderRadius: "15px",
                                                    background: (0,_utility_services_keywordHelper__WEBPACK_IMPORTED_MODULE_9__/* .getKeywordDificultyColorRange */ .XP)(cluster[subName][key] || 0)
                                                }
                                            }) : null)
                                        ]
                                    })
                                }, index);
                            })
                        ]
                    })
                }, index);
            })
        ]
    });
}
Row.propTypes = {
    name: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string.isRequired),
    cluster: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().object.isRequired),
    parent_classes: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().any),
    isSingleLevel: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    keyName: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string)
};
var CollapsibleTable = function(param) {
    var data = param.data, isSingleLevel = param.isSingleLevel, classes = param.classes, keyName = param.keyName, columns = param.columns;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        component: _material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z,
        className: classes.tableWrap,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
            "aria-label": "collapsible table",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                    className: classes.tableHead,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                className: classes.tableHead,
                                width: "32px"
                            }),
                            (columns || [
                                {
                                    name: "Keyword Cluster"
                                },
                                {
                                    name: "Avg. Search Volume",
                                    width: "95px"
                                },
                                {
                                    name: "Keyword Difficulty",
                                    width: "81px"
                                }, 
                            ]).map(function(i) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    className: classes.tableHead,
                                    width: i.width,
                                    children: i.name
                                }, i.name);
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    children: data.clusters ? Array.isArray(data.clusters) && keyName ? data.clusters.map(function(obj) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Row, {
                            keyName: keyName,
                            name: obj[keyName],
                            parent_classes: classes,
                            cluster: obj,
                            isSingleLevel: isSingleLevel
                        }, obj[keyName]);
                    }) : Object.keys(data.clusters).map(function(name) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Row, {
                            name: name,
                            parent_classes: classes,
                            cluster: data.clusters[name],
                            isSingleLevel: isSingleLevel
                        }, name);
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: "No Data"
                    })
                })
            ]
        })
    });
};
CollapsibleTable.propTypes = {
    data: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().object.isRequired)
};
/* harmony default export */ __webpack_exports__["Z"] = (CollapsibleTable);


/***/ }),

/***/ 53041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kf": function() { return /* binding */ getKeywordSuitabilityRatingColorRange; },
/* harmony export */   "Mj": function() { return /* binding */ isSuggestedElementsHaveChild; },
/* harmony export */   "Uk": function() { return /* binding */ getKeywordTypeCount; },
/* harmony export */   "XP": function() { return /* binding */ getKeywordDificultyColorRange; }
/* harmony export */ });
/* unused harmony exports getHeaderString, getPotentialHeaderString, getRecalculateCountString */
var isSuggestedElementsHaveChild = function(elementId, storedPageAllHtmlData) {
    var ref;
    var findParentEleDetails = storedPageAllHtmlData.find(function(el) {
        return el.id === elementId;
    });
    var isSiblingsAvailable = false;
    if (findParentEleDetails && (findParentEleDetails === null || findParentEleDetails === void 0 ? void 0 : (ref = findParentEleDetails.siblings) === null || ref === void 0 ? void 0 : ref.length) > 0) {
        findParentEleDetails.siblings.forEach(function(sibElement) {
            for(var i = 0; i < storedPageAllHtmlData.length; i++){
                if (storedPageAllHtmlData[i].id == sibElement.id) {
                    isSiblingsAvailable = true;
                    break;
                }
            }
        });
    }
    return isSiblingsAvailable;
};
var getKeywordDificultyColorRange = function(score) {
    switch(true){
        case score <= 24:
            return "#EFBF2E";
        case score <= 49:
            return "#F2994A";
        case score <= 74:
            return "#E57310";
        case score <= 90:
            return "#EB5757";
        case score <= 100:
            return "#EB5757";
        default:
            return "";
    }
};
var getKeywordSuitabilityRatingColorRange = function(score) {
    switch(true){
        case score <= 49:
            return "#E57310";
        case score > 49 && score < 80:
            return "#EFBF2E";
        case score >= 80:
            //#219653
            return "#51D497";
        default:
            return "";
    }
};
var getKeywordTypeCount = function(list) {
    var brandedCount = 0;
    var nonBrandedCount = 0;
    // skip subkeywords
    var keywordClusterList = list.filter(function(kw) {
        return !kw.sub_keyword;
    });
    keywordClusterList.forEach(function(item) {
        if (item.is_branded) {
            brandedCount++;
        } else {
            nonBrandedCount++;
        }
    });
    return {
        brandedTargetedKeywordCount: brandedCount,
        nonBrandedTargetedKeywordCount: nonBrandedCount
    };
};
var getHeaderString = function(details, isBrandedIncluded) {
    var countArray = [];
    if (details.nonBrandedTargetedKeywordCount) {
        countArray.push("".concat(details.nonBrandedTargetedKeywordCount, " non-branded keywords"));
    }
    if (details.brandedTargetedKeywordCount && isBrandedIncluded) {
        countArray.push("".concat(details.brandedTargetedKeywordCount, " branded keywords"));
    }
    if (details.newKeywordsCount) {
        countArray.push("".concat(details.newKeywordsCount, " new non-branded keywords"));
    }
    if (details.newBrandedKeywordsCount && isBrandedIncluded) {
        countArray.push("".concat(details.newBrandedKeywordsCount, " new branded keywords"));
    }
    return countArray.join(", ");
};
var getPotentialHeaderString = function(potentialData, isBrandedIncluded) {
    var dataDetails = getKeywordTypeCount(potentialData);
    var countArray = [];
    if (dataDetails.nonBrandedTargetedKeywordCount) {
        countArray.push("".concat(dataDetails.nonBrandedTargetedKeywordCount, " non-branded keywords"));
    }
    if (dataDetails.brandedTargetedKeywordCount && isBrandedIncluded) {
        countArray.push("".concat(dataDetails.brandedTargetedKeywordCount, " branded keywords"));
    }
    return countArray.join(", ");
};
var getRecalculateCountString = function(targetdKeywordCountData) {
    var countArray = [];
    if (targetdKeywordCountData.newKeywordsCount) {
        countArray.push("".concat(targetdKeywordCountData.newKeywordsCount, " non-branded"));
    }
    if (targetdKeywordCountData.newBrandedKeywordsCount) {
        countArray.push("".concat(targetdKeywordCountData.newBrandedKeywordsCount, " branded"));
    }
    return countArray.join(", ");
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5365,4593,6787,9082,7451,4977,1875,3489,9774,2888,179], function() { return __webpack_exec__(85925); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);